module.exports = __webpack_public_path__ + "img/ala_overview_trigger.27e303d1.jpg";